import { PackModel } from "./pack.model";
export class AmountPackModel {
	amount: number;
	packId: string | PackModel;

	constructor(obj: { amount: number; packId: string | PackModel }) {
		this.amount = obj.amount;
		this.packId = obj.packId;
	}

	get licenceNumber(): string {
		if (typeof this.packId !== "string") {
			return (Number(this.packId.licenceNumber) * this.amount).toString();
		} else {
			return "";
		}
	}

	get type(): string | 0 {
		if (typeof this.packId !== "string") {
			return this.packId.type;
		} else {
			return 0;
		}
	}

	get price(): number {
		if (typeof this.packId !== "string") {
			return Number(this.packId.packPrice[0].amount) * this.amount;
		} else {
			return 0;
		}
	}

	get renewPrice(): number {
		if (typeof this.packId !== "string") {
			return Number(this.packId.renovationPrice[0].amount) * this.amount;
		} else {
			return 0;
		}
	}

	get subscriptionUnit(): string {
		if (typeof this.packId !== "string") {
			return this.packId.subscriptionUnit;
		} else {
			return "";
		}
	}
	get subscriptionAmount(): number | undefined {
		if (typeof this.packId !== "string") {
			return this.packId.subscriptionAmount;
		} else {
			return undefined;
		}
	}

	get name(): string {
		if (typeof this.packId !== "string") {
			return this.packId.name;
		} else {
			return "";
		}
	}

	get packMongoId(): string | undefined {
		return typeof this.packId === "string" ? this.packId : this.packId._id;
	}

	get pack(): PackModel | undefined {
		if (typeof this.packId !== "string") return this.packId;
	}

	get core(): boolean {
		return this.pack?.type === "core";
	}

	public toPost(): { packId: string; amount: number } {
		return {
			packId: this.packMongoId,
			amount: this.amount,
		};
	}

	public isSamePack(amount_pack: AmountPackModel): boolean {
		const m_pack_id = this.packMongoId;
		const amount_pack_id = amount_pack.packMongoId;

		return amount_pack_id === m_pack_id;
	}
}
